import { upload } from "./upload";
import { popError } from "./Popup";

export async function uploadFile(type: string, pagename: string): Promise<string | false> {

    return new Promise((resolve) => {
        const input = document.createElement('input');
        input.accept = `${type}/*`;
        input.type = 'file';
        input.name = 'file';
        input.style.zIndex = '1000';

        input.addEventListener('change', async (e: Event) => {
            e.preventDefault();

            //  Verify that a file actually was seleted
            if (!input.files || input.files.length == 0) {
                popError('Ingen fil valdes!');
                resolve(false);
            }
            const file = input.files ? input.files[0] as File : null;

            // Upload!
            const uploadedFile = await upload(pagename, type, file as File);
            if (!uploadedFile) {
                popError('Uppladdningen misslyckades!');
                resolve(false);
            }
            resolve(uploadedFile);

        });
        input.click();
    });
}

